import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { Resolver } from "dns";
import { Server } from "http";
import { BehaviorSubject } from "rxjs";
import { tap } from "rxjs/operators";
import { ServerType } from "src/service/app-init.service";
import { RestApiService } from "src/service/rest-api.service";

@Injectable({
  providedIn: "root",
})
export class PaymentInformationService implements Resolve<any> {
  constructor(private restApiService: RestApiService) {}

  subPaymentMethods = new BehaviorSubject<any>([]);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.getSubPaymentMethods()
  }

  getSubPaymentMethods() {
    return this.restApiService
      .get(ServerType.STRIPE, "paypal/sub-payment-methods")
      .pipe(tap((result) => this.subPaymentMethods.next(result)));
  }

  updateSubscription(subscriptionId: string) {
    return this.restApiService.post(ServerType.STRIPE, "paypal/update-payment-method", {subscriptionId})
      .toPromise().then(res => {
        console.log(res);
        return res.subscriptionId;
      });
  }

  updatePaymentMethod(body) {
    return this.restApiService.post(
      ServerType.STRIPE,
      "paypal/update-payment-method",
      body
    );
  }
}
